type SystemsCountProps = Readonly<{
  shownCount: number;
  totalCount: number;
  testId?: string;
}>;

export default function SystemsCount({
  shownCount,
  totalCount,
  testId = 'systems-count'
}: SystemsCountProps) {
  if (totalCount === 0) return null;

  return (
    <p data-testid={testId} className='text-xs text-gray-500'>
      Showing {Math.min(shownCount, totalCount)} of {totalCount} system
      {totalCount === 1 ? '' : 's'}
    </p>
  );
}
